import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "../../../../hooks/useMerchant";
import {
  RentalsMerchantPortalRouterOutputs,
  useTRPC,
} from "../../../../trpc/client";

export type SubscriptionCharge =
  RentalsMerchantPortalRouterOutputs["subscriptions"]["listSubscriptionCharges"][number];

export function useFetchRewardRecipients() {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading } = useQuery(
    trpc.subscriptions.listSubscriptionCharges.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "", rewardRecipients: true },
      { enabled: !!merchant?.id }
    )
  );

  return { rewardRecipients: data ?? [], isLoading };
}
